<template>
  <div>
    <!-- 取大險種 -->
    <div class="form-group row">
      <label class="col-2 text-right">取大險種</label>
      <div class="col-10 d-inline-grid">
        <input
          type="text"
          class="form-control form-control-inline show-input w-200"
          :class="{ disabled: true }"
        />
      </div>
    </div>

    <!-- 取大期間 -->
    <div class="form-group row">
      <label class="col-2 text-right">取大期間</label>
      <div class="col-10 d-inline-grid">
        <!-- 取大期間-1 -->
        <div class="radio radio-inline ml-15 mb-15">
          <input
            type="radio"
            id="getMax-1"
            v-model="form.max_period"
            value="1"
          />
          <label class="hide-label" for="getMax-1"></label>
          <span class="lh-40 ml-50">終身</span>
        </div>
        <!-- 取大期間-2 -->
        <div class="radio radio-inline ml-15 mb-15">
          <input
            type="radio"
            id="getMax-2"
            v-model="form.max_period"
            value="2"
          />
          <label class="hide-label" for="getMax-2"></label>
          <span class="lh-40 ml-50">繳費期間</span>
        </div>
        <!-- 取大期間-3 -->
        <div class="radio radio-inline ml-15 mb-15">
          <input
            type="radio"
            id="getMax-3"
            v-model="form.max_period"
            value="3"
          />
          <label class="hide-label" for="getMax-3"></label>
          <input
            type="number"
            class="form-control form-control-inline show-input w-80 ml-50"
            :class="{ 'is-invalid': validate.isYearAfterStartErr }"
            :min="0"
            oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
            maxlength="3"
            v-model.number="form.year_after_start"
          />
          <span class="lh-40">年後開始</span>
        </div>
        <!-- 取大期間-4 -->
        <div class="radio radio-inline ml-15 mb-15">
          <input
            type="radio"
            id="getMax-4"
            v-model="form.max_period"
            value="4"
          />
          <label class="hide-label" for="getMax-4"></label>
          <input
            type="number"
            class="form-control form-control-inline show-input w-80 ml-50"
            :class="{ 'is-invalid': validate.isMaxStartErr }"
            :min="0"
            oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
            maxlength="3"
            v-model.number="form.max_start"
          />
          <select
            class="form-control form-control-inline form-wide w-100"
            v-model="form.max_start_unit"
          >
            <option
              v-for="item in pageControl.coveragePeriodUnits"
              :key="item.value"
              :value="item.value"
            >
              {{ item.text }}
            </option>
          </select>
          <span class="lh-40">到</span>
          <input
            type="number"
            class="form-control form-control-inline show-input w-80"
            :class="{ 'is-invalid': validate.isMaxEndErr }"
            :min="0"
            maxlength="3"
            oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
            v-model.number="form.max_end"
          />
          <select
            class="form-control form-control-inline form-wide w-100"
            v-model="form.max_end_unit"
          >
            <option
              v-for="item in pageControl.coveragePeriodUnits"
              :key="item.value"
              :value="item.value"
            >
              {{ item.text }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <!-- 取大項目 -->
    <div class="form-group row">
      <label class="col-2 text-right">取大項目</label>
      <div class="col-10 d-inline-grid">
        <div v-for="(detail, index) in details" :key="index" class="checkbox radio-inline ml-15 mb-15">
          <!-- 取大項目Checkbox -->
          <input
            type="checkbox"
            :id="`maxItem${index}`"
            :disabled="detail.disabled"
            :value="index"
            v-model="form.max_item"
          />
          <label class="hide-label" :for="`maxItem${index}`"></label>
          <!-- 第一個運算基底 -->
          <select
            v-model="detail.calculationbasis1"
            :disabled="detail.disabled"
            :class="{ 'is-invalid': detail.is_calculationbasis1_error }"
            class="form-control form-control-inline form-wide w-250 ml-50"
            @change="changeCalculationBasis(index)"
          >
            <option value="0"></option>
            <option
              v-for="item in pageControl.maxCalculationBasis"
              :key="`calculation-basis-1-${item.value}`"
              :value="item.value"
            >
              {{ item.text }}
            </option>
          </select>
          <!-- 第一個運算倍數 -->
          <input
            type="number"
            min="0"
            maxlength="5"
            oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
            v-model="detail.calculationbasis1_value"
            :disabled="detail.disabled"
            :class="{ 'is-invalid': detail.is_calculationbasis1_value_error }"
            class="form-control form-control-inline show-input w-80"
          />
          <span class="lh-40">倍</span>
          <!-- 運算符號 -->
          <select
            v-model="detail.operator"
            :disabled="detail.disabled"
            :class="{ 'is-invalid': detail.is_operator_error }"
            class="form-control form-control-inline form-wide w-80"
          >
            <option value="0"></option>
            <option
              v-for="item in pageControl.maxOperator"
              :key="`operator-${item.value}`"
              :value="item.value"
            >
              {{ item.text }}
            </option>
          </select>
          <!-- 第二個運算基底 -->
          <select
            v-model="detail.calculationbasis2"
            :disabled="detail.disabled"
            :class="{ 'is-invalid': detail.is_calculationbasis2_error }"
            class="form-control form-control-inline form-wide w-250"
          >
            <option value="0"></option>
            <option
              v-for="item in pageControl.maxCalculationBasis"
              :key="`calculation-basis-2-${item.value}`"
              :value="item.value"
            >
              {{ item.text }}
            </option>
          </select>
          <!-- 第二個運算倍數 -->
          <input
            type="number"
            min="0"
            maxlength="5"
            oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
            v-model="detail.calculationbasis2_value"
            :disabled="detail.disabled"
            :class="{ 'is-invalid': detail.is_calculationbasis2_value_error }"
            class="form-control form-control-inline show-input w-80"
          />
          <span class="lh-40">倍</span>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
export default {
  name: "AddGetMaxFormulaComponent3",
  data() {
    return {}
  },
  props: {
    pageControl: {
      type: Object,
      default: () => {
        return {};
      },
    },
    form: {
      type: Object,
      default: () => {
        return {};
      },
    },
    validate: {
      type: Object,
      default: () => {
        return {};
      },
    },
    details: {
      type: Array,
      default: new Array(),
    },
  },
  computed: {
  },
  methods: {
    changeCalculationBasis(index) {
      if(this.details.hasOwnProperty(index+1)) {
        this.details[index+1].disabled = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.lh-40 {
  line-height: 40px;
}

.w-80 {
  width: 80px !important;
}

.w-100 {
  width: 100px !important;
}

.mb-15 {
  margin-bottom: 15px;
}

.ml-50 {
  margin-left: 50px !important;
}

.show-input {
  opacity: unset;
  position: unset;
}

.searchArea {
  border-color: #027a39;
  border-width: 3px;
  background-color: white;
}

.d-inline-grid {
  display: inline-grid;
}

.hide-label {
  height: 0;
}

.disabled {
  pointer-events: none;
  opacity: 0.8;
  cursor: not-allowed;
  border-color: transparent;
  color: #989ca2;
  background: #f5f5f5;
  box-shadow: inset 0 -1px 0 0 #e2e2e2;
}
</style>
  